import considerationsService from '../../../services/voucher/considerations-service';

import {
  FETCH_CONSIDERATIONS_SUCCESS,
  FETCH_VOUCHER_OPTIONS_SUCCESS,
  UPDATE_CONSIDERATIONS_IN_MODAL,
  REORDER_CONSIDERATIONS_SUCCESS,
} from '../action-types';

// action creators
const fetchLeaseConsiderationTypeOptionsSuccess = options => ({
  type: FETCH_VOUCHER_OPTIONS_SUCCESS,
  payload: { leaseConsiderationTypeOptions: options },
});

const fetchConsiderationsSuccess = considerations => ({
  type: FETCH_CONSIDERATIONS_SUCCESS,
  payload: considerations,
});

const updateCosiderationsInModalSuccess = considerations => ({
  type: UPDATE_CONSIDERATIONS_IN_MODAL,
  payload: considerations,
});

// dispatches
const fetchLeaseConsiderationTypeOptions = () => (dispatch) => {
  considerationsService.fetchLeaseConsiderationTypeOptions()
    .then(options => dispatch(fetchLeaseConsiderationTypeOptionsSuccess(options)))
    .catch(error => console.log('Error fetching lease consideration type options'));
};

const fetchConsiderations = dealId => dispatch => considerationsService.fetchConsiderations(dealId)
  .then((considerations) => {
    dispatch(fetchConsiderationsSuccess(considerations));
    return considerations;
  })
  .catch(error => console.log('Error fetching considerations'));

const reorderConsiderationsSuccess = (considerations) => ({
  type: REORDER_CONSIDERATIONS_SUCCESS,
  payload: considerations,
});

const normalizeReorderConsiderationsResponse = (response, fallbackConsiderations = []) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return fallbackConsiderations;
};

const reorderConsiderations = considerationsArray => (dispatch, getState) => {
  const previousConsiderations = getState().voucherConsiderations?.considerations || [];
  const reorderedById = considerationsArray.reduce((lookup, consideration) => ({
    ...lookup,
    [consideration.id]: consideration,
  }), {});
  const optimisticConsiderations = previousConsiderations.map(consideration => (
    reorderedById[consideration.id]
      ? { ...consideration, ...reorderedById[consideration.id] }
      : consideration
  ));

  dispatch(reorderConsiderationsSuccess(optimisticConsiderations));

  return considerationsService.reorderConsiderations(considerationsArray)
    .then((considerationsOrderedResponse) => {
      const normalizedConsiderations = normalizeReorderConsiderationsResponse(
        considerationsOrderedResponse,
        optimisticConsiderations,
      );
      dispatch(reorderConsiderationsSuccess(normalizedConsiderations));
      return normalizedConsiderations;
    })
    .catch(error => {
      dispatch(reorderConsiderationsSuccess(previousConsiderations));
      console.error('Error reordering considerations:');
      throw error;
    });
};

const updateConsiderations = dealId => (dispatch) => {
  considerationsService.fetchConsiderations(dealId)
    .then((considerations) => {
      dispatch(fetchConsiderationsSuccess(considerations));
    })
    .catch(error => console.log('Error fetching considerations'));
};

const updateConsiderationsInModal = considerations => dispatch =>
  dispatch(updateCosiderationsInModalSuccess(considerations));

export {
  fetchConsiderations,
  reorderConsiderations,
  updateConsiderations,
  updateConsiderationsInModal,
  fetchLeaseConsiderationTypeOptions,
};
